import { render } from "./ExchangeGroupCard.vue?vue&type=template&id=09317ab0&ts=true"
import script from "./ExchangeGroupCard.vue?vue&type=script&lang=ts"
export * from "./ExchangeGroupCard.vue?vue&type=script&lang=ts"

import "./ExchangeGroupCard.vue?vue&type=style&index=0&id=09317ab0&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__